import React, { useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import CustomTable from "../../../components/CustomTable";
import { useNavigate } from "react-router-dom";
import { getKycRewardConfigurations } from "../../../services/kycRewardService";
import { formatDate } from "../../../libs/utils";
import Swal from "sweetalert2";
import { useTimezone } from "../../../contexts/TimezoneContext";

function KycRewardConfigurationList() {
  const { timezoneValue } = useTimezone();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const columns = [
    { id: "age", label: "Age", minWidth: 20, enableSort: true },
    {
      id: "cashback_amount",
      label: "Cashback Amount",
      minWidth: 35,
      align: "left",
    },
    {
      id: "expiry_date",
      label: "Expiry Date",
      minWidth: 85,
      align: "left",
      format: (value) => formatDate(value, timezoneValue),
    },
  ];

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      getKycRewardConfigurations().then((response) => {
        const { success, error, data } = response || {};
        setLoading(false);
        if (success) {
          if (data?.length && typeof data === "object") {
            setRows(data);
          } else {
            setRows([]);
          }
        } else {
          Swal.fire({
            title: "Oops",
            text: error.message || "Something went wrong",
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
      });
    }, 1000);
  }, []);

  return (
    <Box sx={{ px: 6 }} className={`main-box`}>
      <div className={`bankAddRuleHeader mb-3`}>
        <div
          style={{
            display: "flex",
            padding: "1.5rem 0",
            alignItems: "center",
          }}
        >
          <Typography sx={{ color: "#33343a" }} variant="h4" component="h4">
            KYC Reward Configurations
          </Typography>
          {loading && (
            <div
              style={{
                marginLeft: "12px",
                color: "#a0a0a0",
                fontSize: "24px",
              }}
            >
              <i
                className={`fa fa-refresh ${loading === true ? "fa-spin" : ""}`}
                aria-hidden="true"
              ></i>
            </div>
          )}
        </div>

        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/app/kyc-reward-configuration/edit")}
        >
          Create/Edit Reward
        </Button>
      </div>
      <CustomTable data={rows} columns={columns} />
    </Box>
  );
}

export default KycRewardConfigurationList;
